import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/index.scss';


// pre made tailwind components
import VueTailwind from 'vue-tailwind';
import settings from '@/assets/vue-tailwind';
Vue.use(VueTailwind, settings);

// toast notifications
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

Vue.config.productionTip = false;



import firebase from 'firebase/app';
import 'firebase/firestore';
// Initialize Firebase
firebase.initializeApp({
  apiKey: "AIzaSyAIhJZq55iWqKgI_pouFlazxd_Lkh_55-U",
  authDomain: "mop-forms.firebaseapp.com",
  projectId: "mop-forms",
  storageBucket: "mop-forms.appspot.com",
  messagingSenderId: "727407912730",
  appId: "1:727407912730:web:ba740afe0393dafc46aea3"
});

const db = firebase.firestore();
export { db };



// let unsubscribe;

new Vue({
  router,
  store,
  mounted() {
    // Set the number of steps (questions) and exam type (muscle group)
    this.$store.dispatch('setup_exam');
  },
  methods: {
    redirect() {
      location.replace("https://www.myorthopedicproblem.com/");
    },
    random() {
      const uuid = (a) => a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
      return uuid();
    },
  },
  // beforeDestroy() {
  //   unsubscribe();
  // },
  render: h => h(App)
}).$mount('#app')
